import { ActivatedRoute, Router } from '@angular/router';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  Renderer2,
} from '@angular/core';
import { HttpResponse, HttpResponseBase } from '@angular/common/http';
import { AuthService } from '../services/auth/auth.service';
import { IAlert } from '../alert/models/alert.interface';
import { AlertTypeEnum } from '../alert/enum/alert-type.enum';
import '@desyre/design-system-web/dist/alert.js';

// component reutilizável de login
import '@rede/rede-login-page/dist/main.bundle';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { filter, tap } from 'rxjs';
import { AuthCedentialsService } from '../services/guards/auth-credentials.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent implements OnInit {
  loading = false;
  loginError = false;
  loginMessage = '';
  passwordMessage = '';
  token: string | null = null;
  genericLoginError =
    'Houve um problema ao realizar o login Rede. Tente novamente mais tarde.';
  genericError =
    'Ocorreu um erro. Tente novamente ou entre em contato com o suporte do solicitante.';
  alert: IAlert = {
    type: AlertTypeEnum.Negative,
    title: 'Falha',
    description: this.genericError,
    visible: false,
  };
  private errorKeyWord = 'error=';

  constructor(
    private readonly authService: AuthService,
    private readonly authCedentialsService: AuthCedentialsService,
    private readonly recaptchaV3Service: ReCaptchaV3Service,
    private readonly renderer: Renderer2,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.renderer.addClass(document.body, 'recaptcha');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'recaptcha');
  }

  ngAfterContentInit() {
    this.route.queryParams
      .pipe(
        filter((queryParams) => queryParams.hasOwnProperty('error')),
        tap((queryParams) => {
          this.openAlert();
        })
      )
      .subscribe();
  }

  handleSubmit(event: any): void {
    this.closeAlert();
    const { login, password } = event.detail;
    this.loginMessage = this.getFieldMessage('e-mail', login);
    this.passwordMessage = this.getFieldMessage('senha', password);

    if (!this.loginMessage && !this.passwordMessage && !this.loading) {
      this.loading = true;

      this.recaptchaV3Service.execute('login').subscribe((recaptchaToken) => {
        this.authService.login(login, password, recaptchaToken).subscribe({
          next: (data) => {
            this.loading = false;
            if (data instanceof HttpResponseBase) {
              const response = data as HttpResponse<any>;
              this.redirectToConsent(response);
            }
          },
          error: (err) => {
            this.loading = false;
            if (err.error && err.error.includes(this.errorKeyWord)) {
              const errorDescription = err.error.slice(
                err.error.indexOf(this.errorKeyWord) + this.errorKeyWord.length
              );
              this.setAlert({
                type: AlertTypeEnum.Negative,
                title: 'Falha no login',
                description: unescape(errorDescription),
              });
            } else {
              this.alert.description = this.genericLoginError;
            }
            this.openAlert();
          },
        });
      });
    }
  }

  redirectToConsent(response: any) {
    if (response && response.ok && response.headers.get('redirectConsent')) {
      const respStrinToJson = JSON.parse(response.body);
      this.authCedentialsService.setToken(respStrinToJson.token);
      const redirectUrl = response.headers.get('redirectConsent');

      this.authService.redirectUrl(redirectUrl).subscribe((data) => {
        if (data.redirectUrl.includes('https')) {
          window.location.href = data.redirectUrl;
        } else if (data.redirectUrl) {
          const url = `consent?${data.redirectUrl}`;
          const decodedUrl = decodeURIComponent(url);
          const urlTree = this.router.parseUrl(decodedUrl);
          this.router.navigateByUrl(urlTree);
        } else {
          this.authCedentialsService.removeToken();
          window.location.href = response.url;
        }
      });
    }
  }

  public setAlert(newAlert: IAlert) {
    this.alert = newAlert;
  }

  public closeAlert() {
    this.alert.visible = false;
  }

  public openAlert() {
    this.alert.visible = true;
  }

  public getFieldMessage(field: string, value: string) {
    return value ? '' : `o campo ${field} deve ser preenchido`;
  }
}
